import { connect } from 'react-redux';
import { stepDialogUpdate, stepChoicesUpdate, nextStepsUpdate } from '../../../actions';
import QuestionContent from './QuestionContent';

const mapStateToProps = ({ stepDialog }) => {
    return {
        step: stepDialog.step,
        data: stepDialog.nextSteps,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onChange: (id, value) => {
        dispatch(stepDialogUpdate({ [id]: value }));
    },
    onChoicesUpdate: (index, value) => {
        dispatch(stepChoicesUpdate({ index, value }));
    },
    onNextStepsChange: (nextSteps) => {
        dispatch(nextStepsUpdate(nextSteps));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionContent);
